import { IHierarchyNode } from '@/shared/api-client/models/hierarchy-node';
import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';
import { UriHelper } from '@/shared/helpers/uri-helper';
import { HierarchyFinder } from '@/shared/helpers/hierarchy-finder';
import { StringComparer } from '@/shared/helpers/string-comparer';
import { NameOf } from '@/shared/helpers';

interface IViewModel<T> {
    currentNode?: IHierarchyNode<T>;
}

@Component({
    name: 'hierarchyDropdownComponent'
})
export default class HierarchyDropdownComponent<T> extends Vue {

    @Prop() public nodes!: IHierarchyNode<T>[];
    @Prop() public current?: IHierarchyNode<T>;
    @Prop() public translations!: { [key: string]: string; };
    @Prop({ default: false }) public disabled?: boolean;
    @Prop({ default: 1 }) public level?: number;

    public viewModel: IViewModel<T> = {}

    @Emit('selected-node-changed')
    public emitSelectedNode(node: (IHierarchyNode<T> | undefined)): (IHierarchyNode<T> | undefined) {
        return node;
    }

    @Watch('current', { immediate: true, deep: true })
    onCurrentChange(newVal: IHierarchyNode<T> | undefined, oldVal: IHierarchyNode<T> | undefined) {

        if (newVal == null) {
            return;
        }

        const currentNodeUri = UriHelper.extractUriSegments(newVal.uri, this.level || 1);

        const node = HierarchyFinder.find(this.nodes, x => StringComparer.compare(x.uri, currentNodeUri));

        this.$set(this.viewModel, NameOf.property(this.viewModel, x => x.currentNode), node);
    }

    public get subNodes(): (IHierarchyNode<T>[] | undefined) {

        return this.viewModel?.currentNode?.nodes;
    }

    public setNode(node: IHierarchyNode<T>): void {

        this.signaledChangedNode(node);
    }

    public signaledChangedNode(node: IHierarchyNode<T>): void {

        this.emitSelectedNode(node);
    }
}
